import React, { ChangeEvent, useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import Button from '../../common/buttons/Button';
import Modal from 'react-modal';
import InputText from '../../common/inputs/InputText';
import { closeUserOrgMngReactModal_add_dept } from '../../../helpers/h-react-modals';
import { useAppSelector } from '../../../redux/hooks';
import { addDeptHandler, modifyDeptHandler } from '../../../helpers/h-orgUserMng';
import { toast } from 'react-toastify';
import { getChildDeptCountByDeptCode } from '../../../helpers/h-treeView';
import { t } from 'i18next';
import { useLanguage } from '../../provider/LanguageProvider';

const customStyles = {
  overlay: {
    zIndex: 99,
  },
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    minWidth: '21.875rem',
    padding: 0,
    // minHeight: '12.25rem',
  },
};

interface Props {
  isOpen: boolean;
}

const AddDeptReactModal = ({ isOpen = false }: Props) => {
  const {
    orgInfo: { contextDeptInfo },
  } = useAppSelector((state) => state.organizationUserManagement);

  const { languages, setLanguages } = useLanguage();
  const subTitle = useRef<HTMLHeadingElement | null>(null);
  const [newDeptName, setNewDeptName] = useState('');

  const inputHandler = (event: ChangeEvent<HTMLInputElement>) => {
    setNewDeptName(event.target.value);
  };

  function afterOpenModal() {
    if (subTitle.current === null) return;
    subTitle.current.style.color = 'red';
    // subTitle.current.style.color = '#f00';
  }

  const onConfirm = async () => {
    if (!contextDeptInfo) return toast.error(t('ContextMenu.treeContextMenu.treeToast1') as string);
    if (!newDeptName) return toast.error(t('ContextMenu.treeContextMenu.treeToast2') as string);

    const deptcode = contextDeptInfo.deptcode;
    const deptorder = await getChildDeptCountByDeptCode(deptcode);

    if (typeof deptorder !== 'number') return;

    const dept = {
      ...contextDeptInfo,
      deptname: newDeptName,
      deptorder,
    };

    addDeptHandler(dept, languages);
    //setNewDeptName('');
    closeUserOrgMngReactModal_add_dept();
  };

  useEffect(() => {
    if (!isOpen) setNewDeptName('');
  }, [isOpen]);

  return (
    <div>
      <Modal
        isOpen={isOpen}
        onAfterOpen={afterOpenModal}
        onRequestClose={closeUserOrgMngReactModal_add_dept}
        style={customStyles}
        contentLabel="Example Modal"
      >
        <div
          className="flex flex-col h-full px-3
            relative border border-modal-subTitle bg-white z-50 shadow-listbox-options
            rounded
          "
        >
          {/* HEADER */}
          <div className="min-h-[3.5rem] w-full flex flex-col relative">
            {/* <div className="grow font-bold w-full flex items-center truncate">
                페더레이션 신청
              </div> */}
          </div>
          {/* BODY */}
          <div className="grow w-full jcac gap-3 overflow-y-auto text-sm py-defaultY">
            {t('ContextMenu.treeContextMenu.add') as string}
          </div>
          <InputText value={newDeptName} handleChangeInput={inputHandler} />
          {/* FOOTER */}
          <div className="min-h-[6rem] w-full jcac gap-2">
            <Button
              kind="cancel"
              label={t('ContextMenu.treeContextMenu.cancel')}
              onClick={closeUserOrgMngReactModal_add_dept}
            />
            <Button kind="primary" label={t('ContextMenu.treeContextMenu.ok')} onClick={onConfirm} />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default AddDeptReactModal;
